<p-dialog [baseZIndex]="1100" [style]="{'width': '50%', 'max-height': '75%', 'top': '4rem'}" [modal]="true"
    [(visible)]="showSearch" [draggable]="false" [resizable]="false" [closable]="false" class="spotlight-search"
    [dismissableMask]="true" position="top" [positionTop]="100" (onHide)="closeSearch()">
    <ng-template pTemplate="headerless">
        <div class="spotlight-container">
            <div class="header">
                <div>
                    <div class="neo-input-wrapper neo-input-search no-margin" [formGroup]="searchForm">
                        <i class="pi pi-search input-search"></i>
                        <input pInputText type="text" id="spotlight-search-input" placeholder="Search here..."
                            formControlName="search" autocomplete="new-password"
                            (keydown.enter)="globalSearch(this.searchForm.get('search')?.value)">
                        @if (searchForm.get("search")?.value && !loading) {
                        <i class="pi pi-times input-clear" (click)="closeSearch()"></i>
                        }
                        @if (loading) {
                        <p-progressSpinner class="input-clear"
                            [style]="{'width': '16px', 'height': '16px'}"></p-progressSpinner>
                        }
                    </div>
                    <!-- <small class="search-helper">Enter {{SEARCH_MIN_LENGTH}}+ letters to search.</small> -->
                </div>

                <div class="neo-tabs">
                    <div class="neo-tab" [class.active]="activeSearchCategory() === 'all'"
                        (click)="changeActiveSearchCategory('all')">
                        All
                    </div>

                    <div class="neo-tab" [class.active]="activeSearchCategory() === 'event'"
                        (click)="changeActiveSearchCategory('event')">
                        <i class="tab-icon pi pi-calendar"></i>
                        Manage Events
                    </div>

                    <div class="neo-tab" [class.active]="activeSearchCategory() === 'candidates'"
                        (click)="changeActiveSearchCategory('candidates')">
                        <i class="tab-icon pi pi-user"></i>
                        Manage Candidates
                    </div>

                    <div class="neo-tab" [class.active]="activeSearchCategory() === 'role'"
                        (click)="changeActiveSearchCategory('role')">
                        <i class="tab-icon pi pi-briefcase"></i>
                        Manage Roles
                    </div>
                </div>
            </div>

            <div class="spotlight-content" #resultsContainer (scroll)="onResultsScroll($event)">
                @if (!events.length && !roles.length && !candidates.length) {
                <div class="spotlight-no-data">
                    <empty-state style="gap: 0px;">
                        <empty-state-icon>
                            <img style="height: 100px;" src="assets/icons-svg/NoDocuments.svg" />
                        </empty-state-icon>
                        <empty-state-subtitle>
                            {{searchForm.get('search')?.value?.length < SEARCH_MIN_LENGTH
                                ? ("Hey, looks like you haven’t searched for anything yet 👀. Enter at least " + SEARCH_MIN_LENGTH + " characters to begin!")
                                : "No results found — try adjusting your search terms." }} </empty-state-subtitle>
                    </empty-state>
                </div>
                }

                @if (events.length) {
                <div class="spotlight-section">
                    <div class="spotlight-section-heading">
                        MANAGE EVENTS
                    </div>
                    <div class="spotlight-section-content">
                        @for (event of events; track $index) {
                        <div class="section" (click)="openEvent(event)">
                            <div class="icon">
                                <i class="pi pi-calendar"></i>
                            </div>
                            <div class="title">
                                {{event.name}}
                            </div>
                        </div>
                        }
                    </div>
                </div>
                }

                @if (roles.length) {
                <div class="spotlight-section">
                    <div class="spotlight-section-heading">
                        MANAGE JOB ROLES
                    </div>
                    <div class="spotlight-section-content">
                        @for (role of roles; track $index) {
                        <div class="section" (click)="openRole(role)">
                            <div class="icon">
                                <i class="pi pi-briefcase"></i>
                            </div>
                            <div class="title">
                                {{role.name}}
                            </div>
                        </div>
                        }
                    </div>
                </div>
                }

                @if (candidates.length) {
                <div class="spotlight-section">
                    <div class="spotlight-section-heading">
                        MANAGE CANDIDATES
                    </div>
                    <div class="spotlight-section-content">
                        @for (candidate of candidates; track $index) {
                        <div class="section" (click)="openCandidate(candidate)">
                            <div class="icon">
                                <i class="pi pi-user"></i>
                            </div>
                            <div class="title">
                                {{candidate.name}} - {{candidate.email}}
                            </div>
                            @if (openingCandidateEmail === candidate.email) {
                            <p-progressSpinner class="input-clear"
                                [style]="{'width': '16px', 'height': '16px'}"></p-progressSpinner>
                            }
                        </div>
                        }
                    </div>
                </div>
                }

                @if (loadingMore) {
                <div class="loading-more-container">
                    <p-progressSpinner [style]="{'height': '30px'}"></p-progressSpinner>
                </div>
                }
            </div>
        </div>
    </ng-template>
</p-dialog>